/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_Transaction_NoInputs */

const en_settings_credits_transaction_no = /** @type {(inputs: Settings_Credits_Transaction_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transaction`)
};

const zh_settings_credits_transaction_no = /** @type {(inputs: Settings_Credits_Transaction_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流水号`)
};

/**
* | output |
* | --- |
* | "Transaction" |
*
* @param {Settings_Credits_Transaction_NoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_credits_transaction_no = /** @type {((inputs?: Settings_Credits_Transaction_NoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_Transaction_NoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_transaction_no(inputs)
	return zh_settings_credits_transaction_no(inputs)
});
export { settings_credits_transaction_no as "settings.credits.transaction_no" }